export default "__VITE_ASSET__BeNateFM__"